import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as Yup from 'yup';
import { Text } from '@yoweb/ui/components/typography';
import { Grid } from '@yoweb/ui/components/Grid';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { Select } from '@yoweb/ui/components/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getMonthAndDayInitialValues = function getMonthAndDayInitialValues(dateAnswer) {
  var _dateAnswer$answeredV, _dateAnswer$answeredV2;

  return {
    month: dateAnswer === null || dateAnswer === void 0 ? void 0 : (_dateAnswer$answeredV = dateAnswer.answeredValue) === null || _dateAnswer$answeredV === void 0 ? void 0 : _dateAnswer$answeredV.month,
    day: dateAnswer === null || dateAnswer === void 0 ? void 0 : (_dateAnswer$answeredV2 = dateAnswer.answeredValue) === null || _dateAnswer$answeredV2 === void 0 ? void 0 : _dateAnswer$answeredV2.day
  };
};
export var getMonthAndDayValidationSchema = function getMonthAndDayValidationSchema(isOptional, t) {
  var number = Yup.number();
  var baseSchema = Yup.object().shape({
    month: number,
    day: number
  });
  var baseSchemaRequired = Yup.object().shape({
    month: number.required(t('validation.required', {
      ns: 'common'
    })),
    day: number.required(t('validation.required', {
      ns: 'common'
    }))
  });
  return Yup.object().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: baseSchema,
    otherwise: isOptional ? baseSchema : baseSchemaRequired
  });
};
export var MonthAndDayElement = function MonthAndDayElement(_ref) {
  var _values$questionId, _monthAndDayAnswer$ch;

  var instructionHint = _ref.instructionHint,
      monthAndDayAnswer = _ref.monthAndDayAnswer,
      isDisabled = _ref.isDisabled,
      id = _ref.id,
      formikProps = _ref.formikProps;

  if (!monthAndDayAnswer) {
    return null;
  }

  var _id$split = id.split('.'),
      _id$split2 = _slicedToArray(_id$split, 2),
      questionId = _id$split2[0],
      index = _id$split2[1];

  var values = formikProps.values,
      setFieldValue = formikProps.setFieldValue;

  var _ref2 = values === null || values === void 0 ? void 0 : (_values$questionId = values[questionId]) === null || _values$questionId === void 0 ? void 0 : _values$questionId[index],
      month = _ref2.month,
      day = _ref2.day;

  var daysInMonth = (_monthAndDayAnswer$ch = monthAndDayAnswer.choicesList.find(function (choice) {
    return choice.monthKey.toString() === (month === null || month === void 0 ? void 0 : month.toString());
  })) === null || _monthAndDayAnswer$ch === void 0 ? void 0 : _monthAndDayAnswer$ch.numberOfDays;
  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small3",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(Select, {
      id: "".concat(id, ".month"),
      "data-testid": "".concat(id, ".month"),
      name: "".concat(id, ".month"),
      label: monthAndDayAnswer.inputFieldHintMonth,
      options: monthAndDayAnswer.choicesList.map(function (choice) {
        return {
          value: choice.monthKey.toString(),
          label: choice.monthText
        };
      }),
      value: month === null || month === void 0 ? void 0 : month.toString(),
      onChangeCallback: function onChangeCallback(value) {
        return setFieldValue("".concat(id, ".month"), value);
      },
      disabled: isDisabled
    }), /*#__PURE__*/_jsx(Select, {
      id: "".concat(id, ".day"),
      "data-testid": "".concat(id, ".day"),
      name: "".concat(id, ".day"),
      label: monthAndDayAnswer.inputFieldHintDay,
      options: daysInMonth ? Array.from({
        length: daysInMonth
      }, function (_, i) {
        return i + 1;
      }).map(function (d) {
        return {
          value: d.toString(),
          label: d.toString()
        };
      }) : [],
      value: day === null || day === void 0 ? void 0 : day.toString(),
      onChangeCallback: function onChangeCallback(value) {
        return setFieldValue("".concat(id, ".day"), value);
      },
      disabled: isDisabled
    })]
  });
};